import PropTypes from 'prop-types';
import { ActivityCard } from '@adsk/alloy-react-activity-log';
import Theme from '@adsk/alloy-react-theme';
import { StatusCell } from '../../../components';
import { toLongDate, translate } from '../../../helpers';
import { useDueDateTimezone } from '../../../hooks';

export const ACTIVITY_VARIANTS = {
  ADDED: 'added',
  REMOVED: 'removed',
};

const RfiActivityCard = ({ entity, variant, ...rest }) => {
  const { title, customIdentifier, status, dueDate, createdAt } = entity;
  const { dueDateTimeZone } = useDueDateTimezone(createdAt);

  const dueDateString = dueDate
    ? translate('rpPlugin.due', { dueDate: toLongDate(dueDate, dueDateTimeZone) })
    : null;

  const titleString = customIdentifier ? `#${customIdentifier} ${title}` : title;

  const activityTitle =
    variant === ACTIVITY_VARIANTS.ADDED
      ? translate('rpPlugin.ACTIVITY_CARD_TITLE_ADD')
      : translate('rpPlugin.ACTIVITY_CARD_TITLE_REMOVE');

  return (
    <ActivityCard {...rest} title={activityTitle}>
      <div
        style={{
          color: Theme.colors.charcoal900,
          fontWeight: 'bold',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
        dangerouslySetInnerHTML={{ __html: titleString }}
      />
      <div
        css={[
          Theme.typography.heading5,
          {
            alignItems: 'center',
            display: 'flex',
            margin: '6px 0',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          },
        ]}
      >
        <StatusCell status={status} stacked={false} />
        {dueDateString && (
          <span
            style={{
              color: Theme.colors.charcoal900,
              borderLeft: '1px solid',
              borderColor: Theme.colors.charcoal400,
              paddingLeft: '12px',
              marginLeft: '12px',
            }}
          >
            {dueDateString}
          </span>
        )}
      </div>
    </ActivityCard>
  );
};

RfiActivityCard.propTypes = {
  /**
   * The RFI entity we need to render its activity.
   */
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    customIdentifier: PropTypes.string.isRequired,
    createdBy: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    dueDate: PropTypes.string,
  }).isRequired,
  variant: PropTypes.oneOf(Object.values(ACTIVITY_VARIANTS)),
};

export default RfiActivityCard;
